module.exports = __webpack_public_path__ + "img/package-gift-gold-sm.f09ecc68.svg";